import { type ReactNode } from 'react'
import { joinBasePath } from '../utils/joinBasePath'
import { BasePathContext } from './basePathContext'

interface BasePathProviderProps {
  children: ReactNode
  /** Absolute path the landing is mounted at, e.g. `/` or `/smarcel` */
  value: string
}

export const BasePathProvider = ({ children, value }: BasePathProviderProps) => (
  <BasePathContext value={joinBasePath(value)}>{children}</BasePathContext>
)

BasePathProvider.displayName = 'BasePathProvider'
